import { Injectable } from '@angular/core';
import { AccountDepartment } from 'src/app/types/AccountDepartment';
import { AuthorizedOwner } from 'src/app/types/AuthorizedOwner';
import { Business } from 'src/app/types/Business';
import { Country } from 'src/app/types/Country';
import { InviteBusinessRequest } from 'src/app/types/InviteBusinessRequest';
import { AdditionalInfoRequest } from 'src/app/types/requests/AdditionalInfoRequest';
import { BusinessResponsibilitiesRequest } from 'src/app/types/requests/BusinessResponsibilitiesRequest';
import { BusinessSearchRequest } from 'src/app/types/requests/BusinessSearchRequest';
import { CreateBusinessRequest } from 'src/app/types/requests/CreateBusinessRequest';
import { BusinessOnboardingResponse } from 'src/app/types/responses/BusinessOnboardingResponse';
import { State } from 'src/app/types/States';
import {
  getMockBusinessDetail,
  MOCK_ONBOARDING_QUEUE,
} from '../../../pages/admin/admin-kyb-verifications/admin.mock-data';
import {
  OnboardingBusinessDetail,
  OnboardingQueueItem,
  SubmitIdentityVerificationQueryDocumentRequest,
  SubmitIdentityVerificationQueryDocumentResponse,
} from '../../../pages/admin/admin-kyb-verifications/admin.types';
import { BankAccountDetailsInfoRequest } from '../../../types/requests/BankAccountDetailsInfoRequest';
import { CoreService } from '../../core.service';
import { IBusinessService } from '../IBusinessService';
import {
  mockBusinesses,
  mockClientCountries,
  mockCountries,
  mockUSStates,
  mockVendorOnboardingFlowSteps,
  mockVendorOnboardingFlowStepsAfterAdditonalInfoSelection,
  mockVendorOnboardingFlowStepsAfterBankAccountSelectionSuccess,
  mockVendorOnboardingFlowStepsAfterBusinessComplianceCheck,
  mockVendorOnboardingFlowStepsAfterDirectorSelection,
  mockVendorOnboardingFlowStepsAfterSuccessfulBusinessActivitySelection,
} from './mock-data';
@Injectable({
  providedIn: 'root',
})
export class MockOnboardingService implements IBusinessService {
  constructor(private _coreService: CoreService) {}

  async getCountries(): Promise<Country[]> {
    return this._coreService.delayResolve(mockCountries);
  }

  async getClientCountries(): Promise<Country[]> {
    return this._coreService.delayResolve(mockClientCountries);
  }

  async getStates(): Promise<State[]> {
    return this._coreService.delayResolve(mockUSStates);
  }

  async findBusinesses(request: BusinessSearchRequest): Promise<Business[]> {
    // throw {
    //   userMessage: "this is a user sample message",
    //   apiErrorMessage: "this is a technical sample message"
    // } as OpenApiException;

    console.log('Searching businesses with input:', request);
    // if (request.searchKey) {

    // } else {
    //   // call a different API
    // }
    //return this._coreService.delayResolveReject(mockBusinesses);

    if (request.searchKey) {
      if (request.requestType === 'kyc') {
        try {
          const result = mockBusinesses.filter(
            (business) =>
              business.country.name === request.country.name &&
              business.PAN === request.searchKey,
          );
          if (!result.length) {
            return this._coreService.delayReject(new Error('//error content'));
          }
          return this._coreService.delayResolve(result); // Return the result if found
        } catch (error: any) {
          console.error('Error during business search:', error.message);
          return this._coreService.delayReject(error);
        }
      } else {
        return this._coreService.delayResolve(mockBusinesses); // Return all businesses if not 'kyc'
      }
    } else {
      return [];
    }
  }

  async submitBusinessDetails(
    request: CreateBusinessRequest,
    verification_id: string,
  ): Promise<BusinessOnboardingResponse> {
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps:
        mockVendorOnboardingFlowStepsAfterSuccessfulBusinessActivitySelection,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async addAuthorizedOwner(
    owners: AuthorizedOwner[],
  ): Promise<BusinessOnboardingResponse> {
    mockBusinesses[0].directors = owners;
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowSteps,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async submitAuthorizedOwners(
    owners: AuthorizedOwner[],
  ): Promise<BusinessOnboardingResponse> {
    mockBusinesses[0].directors = owners;
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowSteps,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async updateAuthorizedOwner(
    owners: AuthorizedOwner[],
  ): Promise<BusinessOnboardingResponse> {
    console.log('Updating directors', owners);
    let directorsList = mockBusinesses[0].directors
      ? mockBusinesses[0].directors
      : [];
    /*     console.log('directorsList', directorsList);
    const element = directorsList.filter((x) => x.id == owner.id);
    const index: number = directorsList.indexOf(element[0]);
    directorsList[index] = owner; */
    mockBusinesses[0].directors = owners;
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowStepsAfterDirectorSelection,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async deleteAuthorizedOwner(
    owners: AuthorizedOwner[],
  ): Promise<BusinessOnboardingResponse> {
    console.log('Deleting director', owners);
    let directorsList: AuthorizedOwner[] = mockBusinesses[0].directors
      ? mockBusinesses[0].directors
      : [];
    /*     console.log('directorsList', directorsList);
    let list = directorsList.filter((item) => item.id !== owners.id);
    mockBusinesses[0].directors = list;
    console.log('directorsList11', list); */
    mockBusinesses[0].directors = owners;
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowStepsAfterDirectorSelection,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async updateBusinessResponsibilities(
    request: BusinessResponsibilitiesRequest,
  ): Promise<BusinessOnboardingResponse> {
    console.log('Updating business responsibilities', request);
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowStepsAfterBusinessComplianceCheck,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async addAdditionalInfo(
    request: AdditionalInfoRequest,
    verificationId: string,
  ): Promise<BusinessOnboardingResponse> {
    console.log('Adding additional information', request);
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowStepsAfterAdditonalInfoSelection,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async getPurposeCodes(customerId: string): Promise<{
    success: boolean;
    data: any[];
    error: string;
  }> {
    // Mock purpose codes data with realistic codes and statuses
    const mockPurposeCodes = [
      { code: 'P0102', status: 'approved' },
      { code: 'P0801', status: 'approved' },
      { code: 'P0802', status: 'requested' },
      { code: 'P1004', status: 'approved' },
      { code: 'P1006', status: 'requested' },
      { code: 'P1104', status: 'rejected' },
    ];

    return this._coreService.delayResolve({
      success: true,
      data: mockPurposeCodes,
      error: '',
    });
  }

  async submitAndVerify(
    verificationId: string,
  ): Promise<BusinessOnboardingResponse> {
    console.log('Verifying customer', verificationId);
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowStepsAfterAdditonalInfoSelection,
      context: 'new_business_onboarding',
      onboardingStatus: 'completed',
    });
  }

  async inviteBusiness(request: InviteBusinessRequest): Promise<boolean> {
    return this._coreService.delayResolve(true);
  }

  async updateBusiness(body: AccountDepartment, id: string): Promise<boolean> {
    return this._coreService.delayResolve(true);
  }

  getDataPostFirstStep(
    businessType: string,
    countryCode: string,
  ): Promise<BusinessOnboardingResponse> {
    if (countryCode == 'IN') {
      return this._coreService.delayResolve({
        business: mockBusinesses[1],
        flowSteps: mockVendorOnboardingFlowStepsAfterAdditonalInfoSelection,
        context: 'new_business_onboarding',
        onboardingStatus: 'pending',
        onboardingId: 'random_string',
      });
    } else if (countryCode == 'US') {
      return this._coreService.delayResolve({
        business: mockBusinesses[0],
        flowSteps: mockVendorOnboardingFlowStepsAfterAdditonalInfoSelection,
        context: 'new_business_onboarding',
        onboardingStatus: 'pending',
        onboardingId: 'random_string',
      });
    }
    return this._coreService.delayReject(new Error('Invalid code provided.'));
  }

  addBankAccountDetails(
    request: BankAccountDetailsInfoRequest,
    verificationId: string,
  ): Promise<BusinessOnboardingResponse> {
    console.log('Adding bank account details', request);
    return this._coreService.delayResolve({
      business: mockBusinesses[0],
      flowSteps: mockVendorOnboardingFlowStepsAfterBankAccountSelectionSuccess,
      context: 'new_business_onboarding',
      onboardingStatus: 'pending',
    });
  }

  async checkIfUserBecameActive(
    customerId: string,
    selectedCountryCode: string,
  ) {
    return true;
  }

  getIdentityVerifications(): Promise<OnboardingQueueItem[]> {
    return this._coreService.delayResolve([...MOCK_ONBOARDING_QUEUE]);
  }

  getIdentityVerificationDetail(
    identityVerificationId: string,
  ): Promise<OnboardingBusinessDetail | null> {
    const detail = getMockBusinessDetail(identityVerificationId) ?? null;
    return this._coreService.delayResolve(detail);
  }

  submitIdentityVerificationQueryDocument(
    request: SubmitIdentityVerificationQueryDocumentRequest,
  ): Promise<SubmitIdentityVerificationQueryDocumentResponse> {
    return this._coreService.delayResolve({
      verificationId: request.identityVerificationId,
      queryId: request.queryId,
      fileId: request.fileId,
      status: 'SUBMITTED',
    });
  }
}
